// Minimal Node-globals shim. @react-pdf's bundled readable-stream calls
// process.nextTick at runtime (PDF generation), but vite-plugin-node-polyfills'
// process GLOBAL injection is deliberately disabled in vite.config.mts - it
// binds `process` as an import in every module that mentions it, which stops
// the define bridge from replacing process.env.REACT_APP_*. So patch exactly
// what the stream shims need, nothing more. This module must be the FIRST
// import in src/index.tsx.
const g = globalThis as any;
g.process = g.process || {};
g.process.env = g.process.env || {};
g.process.browser = true;
g.process.nextTick =
	g.process.nextTick ||
	((cb: (...args: any[]) => void, ...args: any[]) =>
		queueMicrotask(() => cb(...args)));

export {};
